export const SIGNUP_COMPLETION="SIGNUP_COMPLETION";



/** WEBPACK FOOTER **
 ** ./common/messageTypes.js
 **/